import React from 'react'
import { connect } from 'react-redux'
import FlowRecordMailForm from './FlowRecordMailForm'
class FlowRecordMailList extends React.Component {
    state = {
        flowRecordId: this.props.flowRecordId,
        emailTemplet: this.props.emailTemplet,
    }

    componentDidMount = () => {
        this.doGeFlowRecordMailList()
    }
    componentWillUnmount = () => {
        this.unmount = true
    }
    doGeFlowRecordMailList = () => {
        const { flowRecordId } = this.state
        Tyan.doPostEvent({
            event: 'GeFlowRecordMailList',
            data: { flowRecordId },
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage)
                    Tyan.pubForm.showError(errorMessage)
                else {
                    this.setState({ initValues基本信息 })
                }
            }
        })
    }

    fieldset邮件列表 = () => {
        const { flowRecordId, emailTemplet } = this.state
        return [{
            _grid: '', name: '邮件列表', rowNumbers: true, minRows: 3, /*minRows: 3, maxRows: 11, */ height: '100%',
            columns: [
                { _text: '主题', flex: 6 },
                { _text: '状态', flex: 2 },
                { _datetime: '发送时间', flex: 2 }
            ],
            onDoubleTap: data => {
                Tyan.pubForm.showDialog('邮件信息', props => <FlowRecordMailForm {...props} id={data.id} flowRecordId={flowRecordId} emailTemplet={emailTemplet} onRefresh={() => this.doGeFlowRecordMailList()} />)
            }
        }]
    }

    render() {
        const { showMessage: Message, onClose, showBody: Body } = this.props
        const { errorMessage, initValues基本信息, flowRecordId, emailTemplet } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} minWidth="800" maxWidth="1100"
            controls={[
                { _button: '发送邮件...', handler: () => Tyan.pubForm.showDialog('添加邮件', props => <FlowRecordMailForm {...props} id={-1} flowRecordId={flowRecordId} emailTemplet={emailTemplet} onRefresh={() => this.doGeFlowRecordMailList()} />), },
                { _button: '关闭', icon: 'close', handler: () => onClose && onClose() }
            ]}
            fieldsets={[{ title: '', name: '基本信息', _fieldset: this.fieldset邮件列表() }]}
        />
    }
}

export default connect()(FlowRecordMailList)